import { render, staticRenderFns } from "./DeleteExtraOptionModal.vue?vue&type=template&id=c12f9a84&"
import script from "./DeleteExtraOptionModal.vue?vue&type=script&lang=js&"
export * from "./DeleteExtraOptionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports